// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueSouscriptions = (newValue) => ({
  type: actionTypes.SET_VALUE_SOUSCRIPTION,
  payload: newValue,
});

export const setCurrentPageSouscriptions = (newCurrentPage) => ({
  type: actionTypes.SET_CURRENT_PAGE_SOUSCRIPTION,
  payload: newCurrentPage,
});

export const setSortingSouscriptions = (newSorting) => ({
  type: actionTypes.SET_SORTING_SOUSCRIPTION,
  payload: newSorting,
});
export const setPageSizeSouscriptions = (newValue) => ({
  type: actionTypes.SET_PAGE_SIZE_SOUSCRIPTION,
  payload: newValue,
});

export const setCustomFilterSouscriptions = (newValue) => ({
  type: actionTypes.SET_CUSTOM_FILTERS_SOUSCRIPTION,
  payload: newValue,
});
export const setSortFieldSouscriptions = (newSortField) => ({
  type: actionTypes.SET_SORT_FIELD_SOUSCRIPTION,
  payload: newSortField,
});
export const setOrderSouscriptions = (newOrder) => ({
  type: actionTypes.SET_ORDER_SOUSCRIPTION,
  payload: newOrder,
});
export const setActiveTabSouscriptions = (newActiveTab) => ({
  type: actionTypes.SET_ACTIVE_TAB_SOUSCRIPTION,
  payload: newActiveTab,
});
export const setQuerySouscriptions = (newQuery) => ({
  type: actionTypes.SET_QUERY_SOUSCRIPTION,
  payload: newQuery,
});
export const setActifSouscriptions = (newQuery) => ({
  type: actionTypes.SET_ACTIF_SOUSCRIPTION,
  payload: newQuery,
});
export const setSelectedOptionFiltersSouscriptions = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_FILTERS_SOUSCRIPTION,
  payload: newQuery,
});
export const setSelectedOptionIdSouscriptions = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_ID_SOUSCRIPTION,
  payload: newQuery,
});

export const setColumnSouscriptions = (newValue) => ({
  type: actionTypes.SET_COLUMN_SOUSCRIPTION,
  payload: newValue,
});
